import type { RollbarPayload } from "./payloadTransform.d";

export const payloadTransform = (payload: RollbarPayload) => {
  const { trace } = payload.body;
  const domainRegex = /^(https?):\/\/[a-zA-Z0-9._-]+\.airhelp\.+(ca|com)/;

  if (trace && trace.frames) {
    for (let i = 0; i < trace.frames.length; i += 1) {
      const { filename } = trace.frames[i];
      if (filename) {
        const newstring = trace.frames[i].filename.replace(domainRegex, "https://www.airhelp.com");
        trace.frames[i].filename = newstring;
      }
    }
  }
};
